module.exports = __webpack_public_path__ + "static/WebInterface-d868cb1d6749010a152cd98144cce023.svg";